import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Table,
  Button,
} from "reactstrap"
import { FaChevronLeft, FaChevronRight, FaEye } from "react-icons/fa6"
import Breadcrumb from "../components/Common/Breadcrumb"
import { Badge } from "antd"
import { MdCurrencyPound } from "react-icons/md"
import { fetchData } from "utils/Common_api_functions"
import moment from "moment"
import Loader from "components/Loader/loader"

const statusColors = {
  Success: "green",
  Pending: "yellow",
  Failed: "red",
}

const PaymentsIndex = () => {
  const [page, setPage] = useState(1)
  const [itemsPerPage] = useState(10)
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedPayment, setSelectedPayment] = useState(null)

  const [loading, setLoading] = useState(false)
  const [allPayments, setAllPayments] = useState([])
  const [payments, setPayments] = useState([])

  useEffect(() => {
    getPayments()
  }, [])

  async function getPayments() {
    const APIData = await fetchData(setLoading, "payments")
    if (APIData?.success) {
      setPayments(APIData?.data)
      setAllPayments(APIData?.data)
    }
  }

  const totalPages = Math.ceil(payments?.length / itemsPerPage)
  const finalData = payments?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  )

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  const handleView = payment => {
    setSelectedPayment(payment)
    setModalOpen(true)
  }

  const toggleModal = () => {
    setModalOpen(!modalOpen)
    if (modalOpen) {
      setSelectedPayment(null)
    }
  }

  const [searchString, setSearchString] = useState("")

  useEffect(() => {
    if (searchString === "") {
      setPayments(allPayments)
    } else {
      const filteredData = allPayments.filter(
        item =>
          item?.user?.name
            ?.toLowerCase()
            .includes(searchString.toLowerCase()) ||
          item?.transactionId
            ?.toLowerCase()
            .includes(searchString.toLowerCase()) ||
          item?.status?.toLowerCase().includes(searchString.toLowerCase()) ||
          item?.planType?.toLowerCase().includes(searchString.toLowerCase()) ||
          String(item?.amount)
            ?.toLowerCase()
            .includes(searchString.toLowerCase()) ||
          item?.subscription?.toLowerCase().includes(searchString.toLowerCase())
      )
      setPayments(filteredData)
    }
  }, [searchString])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="Payments" />
        {loading && <Loader />}
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Payments</h4>
                  <div className="form-group">
                    <Input
                      placeholder="Search Payments"
                      value={searchString}
                      onChange={e => setSearchString(e.target.value)}
                    />
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>User Name</th>
                        <th>Plan Name</th>
                        <th>Plan Type</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>Transaction ID</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData.map((payment, index) => (
                        <tr key={payment.id}>
                          <td>{index + 1}</td>
                          <td>{payment?.user?.name}</td>
                          <td>{payment?.subscription}</td>
                          <td>{payment?.planType}</td>
                          <td>
                            <MdCurrencyPound />
                            {payment.amount.toFixed(2)}
                          </td>
                          <td>
                            {moment(payment.createdAt).format("DD-MM-YYYY")}
                          </td>
                          <td>{payment.transactionId || "-"}</td>
                          <td>
                            <Badge
                              color={statusColors[payment.status]}
                              text={payment.status}
                            />
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-info"
                              onClick={() => handleView(payment)}
                            >
                              <FaEye size={12} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {payments.length}{" "}
                    payments.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {[...Array(totalPages)].map((_, i) => {
                      const pageIndex = i + 1
                      return (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            page === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      )
                    })}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal */}
        {selectedPayment && (
          <Modal isOpen={modalOpen} toggle={toggleModal} centered>
            <ModalHeader toggle={toggleModal}>Payment Details</ModalHeader>
            <ModalBody>
              <Table borderless>
                <tbody>
                  <tr>
                    <th>User Name:</th>
                    <td>{selectedPayment.user?.name}</td>
                  </tr>
                  <tr>
                    <th>Amount:</th>
                    <td>
                      <MdCurrencyPound />
                      {selectedPayment.amount.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <th>Date:</th>
                    <td>
                      {moment(selectedPayment.createdAt).format("DD-MM-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <th>Transaction ID:</th>
                    <td>{selectedPayment.transactionId || "-"}</td>
                  </tr>
                  <tr>
                    <th>Status:</th>
                    <td>
                      <Badge
                        color={statusColors[selectedPayment.status]}
                        text={selectedPayment.status}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Subscription Name:</th>
                    <td>{selectedPayment.subscription}</td>
                  </tr>
                  <tr>
                    <th>Plan Type:</th>
                    <td>{selectedPayment.planType}</td>
                  </tr>
                </tbody>
              </Table>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModal}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </Container>
    </div>
  )
}

export default PaymentsIndex
